import React, { useCallback, useContext, useMemo } from 'react';
// import packageJson from '../../../../../package.json';

import { HistoryStackContext } from 'app/home/general-components/HistoryStackContext';
import { LocalizationContext } from 'app/localization/Context';

import { ReactComponent as IconDownloadBlue } from 'images/general/download-blue.svg';
import { ReactComponent as IconUsers } from 'images/setting/users.svg';
import { ReactComponent as IconHome } from 'images/setting/home-management.svg';
import { ReactComponent as IconNext } from 'images/general/back.svg';
import { ReactComponent as IconRoom } from 'images/room/yellow/room.svg';
import { ReactComponent as IconAbout } from 'images/setting/about.svg';
import { ReactComponent as IconWarningCircle } from 'images/general/icon-warning-circle-red.svg';

import './Settings.scss'

function Settings({ negotiatedProtocol, gwUpdateInfo, allUsers, devices }) {
    const hs = useContext(HistoryStackContext);

    const onHomeProfileClick = useCallback(() => {
        hs.push("/homes/profile");
    }, [hs]);

    const onUserManagementClick = useCallback(() => {
        hs.push("/settings/user_management");
    }, [hs]);

    const onRoomManagementClick = useCallback(() => {
        hs.push("/settings/rooms_management");
    }, [hs]);

    const onAboutClick = useCallback(() => {
        hs.push("/settings/about");
    }, [hs]);

    const onMultiOTAClick = useCallback(() => {
        hs.push("/settings/multi_ota");
    }, [hs]);

    const l = useContext(LocalizationContext);
    const s = l.strings;

    const needToShowVersionAlert = (
        gwUpdateInfo.isUpdateNotificationSupported === false ||
        gwUpdateInfo.isNewerVersionAvailable
    );

    const showMultiOTAAlert = useMemo(() => devices.filter(d => d.ota_exists === true).length > 0, [devices]) && (negotiatedProtocol.canOTADeviceFromClient);

    const pendingUserAlert = (allUsers.pendingUsers.length > 0);

    return (
        <div className="setting-list-container">
            <div className="setting-list-header">
                <div className="setting-list-header-label">{s.settings}</div>
            </div>

            <div className="setting-list responsive">
                {/* profile OR user management */}
                {negotiatedProtocol.hasUserManagement ? (
                    <div className={pendingUserAlert ?
                        "setting-cell responsive with-warning-icon" :
                        "setting-cell responsive"} onClick={onUserManagementClick}>
                        <IconUsers className="setting-cell-icon" />
                        <div className="setting-cell-title">{s.userManagement.title}</div>
                        <div />
                        {pendingUserAlert ?
                            <IconWarningCircle className="warning-icon" /> : null}
                        <IconNext className="setting-cell-icon-next" />
                    </div>) : null}
                {/* ) : (
                    <div className="setting-cell" onClick={onProfileClick}>
                        <IconProfile className="setting-cell-icon" />
                        <div className="setting-cell-title">{s.profile}</div>
                        <div />
                        <IconNext className="setting-cell-icon-next" />
                    </div>
                )} */}

                {/* room management */}
                {
                    negotiatedProtocol.hasRoom ? (
                        <div className="setting-cell responsive" onClick={onRoomManagementClick}>
                            <IconRoom className="setting-cell-icon" />
                            <div className="setting-cell-title">{s.rooms.roomManagement}</div>
                            <div />
                            <IconNext className="setting-cell-icon-next" />
                        </div>
                    ) : null
                }

                {/* home list */}
                {/* <div className="setting-cell" onClick={onHomeManagementClick}>
                    <IconHome className="setting-cell-icon" />
                    <div className="setting-cell-title">{s.homeManagement}</div>
                    <div />
                    <IconNext className="setting-cell-icon-next" />
                </div> */}

                {/* home profile */}
                {
                    negotiatedProtocol.canChangeHomeProfile ?
                        <div className="setting-cell responsive" onClick={onHomeProfileClick}>
                            <IconHome className="setting-cell-icon" />
                            <div className="setting-cell-title">{s.homeProfile}</div>
                            <div />
                            <IconNext className="setting-cell-icon-next" />
                        </div> : null
                }

                {/* multi OTA */}
                {
                    negotiatedProtocol.canOTADeviceFromClient ? <div className={showMultiOTAAlert ?
                        "setting-cell responsive with-warning-icon" :
                        "setting-cell responsive"}
                        onClick={onMultiOTAClick}>
                        <IconDownloadBlue className="setting-cell-icon" />
                        <div className="setting-cell-title">{s.multiOTA.title}</div>
                        <div />
                        {showMultiOTAAlert ?
                            <IconWarningCircle className="warning-icon" /> : null}
                        <IconNext className="setting-cell-icon-next" />
                    </div> : null
                }

                {/* about */}
                <div className={needToShowVersionAlert ?
                    "setting-cell responsive with-warning-icon" :
                    "setting-cell responsive"}
                    onClick={onAboutClick}>
                    <IconAbout className="setting-cell-icon" />
                    <div className="setting-cell-title">{s.about}</div>
                    <div />
                    {needToShowVersionAlert ?
                        <IconWarningCircle className="warning-icon" /> : null}
                    <IconNext className="setting-cell-icon-next" />
                </div>

                <div style={{ height: 16 - 8 }} />
            </div>
        </div >
    );
}


export default Settings;
